module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ModalTheme', {
    attrs: {
      "with-content": true,
      "theme": true,
      "fix-height": false
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('template', {
    slot: "main"
  }, [(_vm.loading) ? _c('loader', {
    attrs: {
      "loading": true
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "example-3"
    }
  }, [_c('ClientColorButton', {
    attrs: {
      "size": "xs"
    },
    on: {
      "click": function($event) {
        _vm.checkIdsList = [];
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("checkBoxModal.selectNone")))]), _vm._v(" "), _c('ClientColorButton', {
    attrs: {
      "size": "xs"
    },
    on: {
      "click": function($event) {
        _vm.checkIdsList = _vm.list.map(function (l) { return l.id; });
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("checkBoxModal.selectAll")))]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _vm._l((_vm.list), function(element) {
    return _c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.checkIdsList),
        expression: "checkIdsList"
      }],
      attrs: {
        "type": "checkbox",
        "id": element.id
      },
      domProps: {
        "value": element.id,
        "checked": Array.isArray(_vm.checkIdsList) ? _vm._i(_vm.checkIdsList, element.id) > -1 : (_vm.checkIdsList)
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.checkIdsList,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = element.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.checkIdsList = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.checkIdsList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.checkIdsList = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": element.id
      }
    }, [_vm._v(_vm._s(_vm._f("capitalize")(element.name)) + " ")])])
  })], 2), _vm._v(" "), _c('br'), _vm._v(" "), _c('ClientColorButton', {
    on: {
      "click": function($event) {
        _vm.$emit('submit', _vm.checkIdsList);
        _vm.$emit('closed');
      }
    }
  }, [_vm._v(_vm._s(this.buttonName))])], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76605b30","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/CheckBoxModal.vue
// module id = 3275
// module chunks = 0